<button *ngIf="hasPermission('upload_documents')" (click)="showModal()" style="margin: 15px" class="floatR marginB"
  nz-button nzType="primary" nzShape="circle">
  <span nz-icon nzType="plus" nzTheme="outline"></span>
</button>

<div>
  <nz-table #templateTable [nzData]="documents" [nzLoading]="spinner" nzShowSizeChanger nzBordered>
    <thead>
      <tr>
        <th>Document Name</th>
        <th>Company</th>
        <th>Provider</th>
        <th>Date Created</th>
        <th>Status</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let document of templateTable.data">
        <td>{{ document.name }}</td>
        <td>{{ document.company }}</td>
        <td>{{ document.provider ? document.provider : document.provider_id}}</td>
        <td>{{ document['createdAt'] | date}}</td>
        <td>
          <nz-tag [nzColor]="document.status === 'disabled' ? 'red' : 'green'">
            {{ document.status === 'disabled' ? 'Disabled' : 'Active' }}
          </nz-tag>
        </td>
        <td>
          <button *ngIf="currentUser?.super_admin" nz-button nz-popover nzPopoverContent="Toggle Status"
            nzType="default" nzShape="circle" (click)="toggleDocumentStatus(document)" style="margin-right: 8px;">
            <span nz-icon [nzType]="document.status === 'disabled' ? 'check-circle' : 'stop'" nzTheme="outline"></span>
          </button>
          <button nz-button nz-popover nzPopoverContent="Edit Document" nzType="primary" nzShape="circle"
            (click)="editDoc(document)">
            <span nz-icon nzType="edit" nzTheme="outline"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>

<nz-modal nzWidth="95%" [(nzVisible)]="addModal" [nzFooter]="null" nzMaskClosable="false" nzDraggable="true"
  nzTitle="Document Options" (nzOnCancel)="handleCancel()">
  <ng-container *nzModalContent>

    <form [formGroup]="addForm">
      <nz-form-item *ngIf="companies?.length > 0">
        <nz-form-label nzRequired>Company</nz-form-label>
        <nz-select [nzDisabled]="editing" nzPlaceHolder="Select Company" formControlName="company" style="width: 100%;">
          <nz-option *ngFor="let c of companies" [nzLabel]="c.name" [nzValue]="c.id"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Provider</nz-form-label>
        <nz-select [nzDisabled]="editing" nzPlaceHolder="Select Provider" formControlName="provider"
          style="width: 100%;">
          <nz-option nzLabel="Generic" nzValue="generic"></nz-option>
          <nz-option *ngFor="let p of providers" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>How To Assign</nz-form-label>
        <nz-select [nzDisabled]="editing" nzPlaceHolder="Select Assign Type" formControlName="assignType"
          style="width: 100%;">
          <nz-option nzLabel="Every User Within Selected Company & New Recruits" nzValue="all"></nz-option>
          <nz-option nzLabel="Every User Within Selected Company & Not New Recruits" nzValue="company"></nz-option>
          <nz-option nzLabel="Only New Recruits" nzValue="new"></nz-option>
          <nz-option nzLabel="None" nzValue="none"></nz-option>
        </nz-select>
      </nz-form-item>
    </form>

    <div class="app">
      <ng-container *ngIf="token">
        <docuseal-builder (onLoad)="loadDoc($event)" withSendButton="false" autosave="false"
          withSignYourselfButton="false" [token]="token" (onSave)="docusealSave($event)"></docuseal-builder>
      </ng-container>
    </div>

  </ng-container>
</nz-modal>